export default function Dashboard() {
  return (
    <div>
      <h1 className="text-3xl font-bold text-gradient mb-8">Dashboard</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="glass rounded-lg p-6">
          <h3 className="text-lg font-semibold text-white mb-2">Servicios</h3>
          <p className="text-3xl font-bold text-primary">12</p>
        </div>
        <div className="glass rounded-lg p-6">
          <h3 className="text-lg font-semibold text-white mb-2">Casos</h3>
          <p className="text-3xl font-bold text-secondary">8</p>
        </div>
        <div className="glass rounded-lg p-6">
          <h3 className="text-lg font-semibold text-white mb-2">Posts</h3>
          <p className="text-3xl font-bold text-accent">24</p>
        </div>
        <div className="glass rounded-lg p-6">
          <h3 className="text-lg font-semibold text-white mb-2">Equipo</h3>
          <p className="text-3xl font-bold text-primary">6</p>
        </div>
      </div>
    </div>
  )
}
